import { Card, CardContent } from "@/components/ui/card";
import type { AdminArticleListItem } from "@/types/article";
import type { ArticleAction } from "./article-columns";
import { ArticleTypeBadge } from "./article-type-badge";
import { ArticleStatusBadge } from "./article-status-badge";
import { ArticleActions } from "./article-actions";
import { formatDate } from "@/lib/format";

interface ArticleCardProps {
  article: AdminArticleListItem;
  onAction: (article: AdminArticleListItem, action: ArticleAction) => void;
}

export function ArticleCard({ article, onAction }: ArticleCardProps) {
  return (
    <Card>
      <CardContent className="p-4 space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex gap-2">
            <ArticleTypeBadge type={article.type} />
            <ArticleStatusBadge publishedAt={article.publishedAt} />
          </div>
          <ArticleActions article={article} onAction={onAction} />
        </div>

        <div className="space-y-1">
          <p className="font-medium text-sm truncate">{article.title.ko}</p>
          <p className="text-xs text-muted-foreground">
            {article.authorInfo.name.ko}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-2">
          <div className="space-y-1">
            <p className="text-xs text-muted-foreground">생성일</p>
            <p className="text-sm">
              {formatDate(article.createdAt, { format: "short" })}
            </p>
          </div>
          <div className="space-y-1">
            <p className="text-xs text-muted-foreground">수정일</p>
            <p className="text-sm">
              {formatDate(article.updatedAt, { format: "short" })}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
